import { ApiProperty } from "@nestjs/swagger";

export class SoPackingStatusRequest{
    @ApiProperty()
    unitId?:number;
    @ApiProperty()
    saleOrderId?:number[];
    @ApiProperty()
    itemSubCategoryId?:number;
    @ApiProperty()
    fromDate?:any;
    @ApiProperty()
    toDate?:any;
    @ApiProperty()
    itemNameId?:number;
    @ApiProperty()
    packingSubCategory?:string;

}